import { FC, useMemo } from 'react';
import { Box, Typography, Button } from '@mui/material';
import useOrder from 'src/hooks/useOrder';
import useCustomer from 'src/hooks/useCustomer';
import MarginDisplay from './orderItemGrid/MarginDisplay';
import useGlobals from 'src/hooks/useGlobals';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import '../../theme/partials/OrderSummaryWidget.css';

interface Props {
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}

const OrderSummaryWidget: FC<Props> = ({ open, onClose, onOpen }) => {
  const sfaOrderId = useOrder((state) => state.order?.sfaOrderId);
  const total = useOrder((state) => state.order?.total);
  const orderWeight = useOrder((state) => state.order?.orderWeight);
  const shipToNumber = useOrder((state) => state.order?.shipToNumber);
  const sfaOrderItems = useOrder((state) => state.order?.sfaOrderItems);
  const customerShipTos = useCustomer((state) => state.customer.shipTos);
  const customerNumber = useCustomer((state) => state.customer.number);
  const { globals } = useGlobals();



  const formatter = useMemo(
    () =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      }),
    []
  );

  return (
    <div className="order-summary-widget">
      {open ? (
        <Box className="order-summary-widget__content">
          <Box className="order-summary-widget__content-header">
            <Typography variant="h6" gutterBottom>
              Order Summary ({sfaOrderItems.length})
            </Typography>
            <Button onClick={() => onClose()}>
              <ChevronRightIcon />
            </Button>
          </Box>

          {sfaOrderItems.length > 0 ? (
            <Box className="order-summary-widget__content-numbers">
              <Box>
                <div className="order-summary-widget__content-numbers-totals">
                  <div>
                    <strong>Total</strong> <span className="order-total pr-2">Total: {formatter.format(total)}</span>
                  </div>
                  <div>{!globals.customerPresent && <MarginDisplay customerNumber={customerNumber} sfaOrderId={sfaOrderId} sfaOrderItemsLength={sfaOrderItems.length} total={total} />}</div>
                </div>
                <p>
                  <strong>Order Weight:</strong> {parseFloat(orderWeight?.toString() || '0').toFixed(2)} lbs
                </p>
              </Box>
              <Box>
                <p>
                  <strong>Min Order Amt</strong> {customerShipTos?.find((s) => s.shipNo === shipToNumber)?.minOrderAmount ?? '0.00'}
                </p>
                <p>
                  <strong>Under Min Charge</strong> {customerShipTos?.find((s) => s.shipNo === shipToNumber)?.underMinCharge ?? '0.00'}
                </p>
                <p>
                  <strong>Over Min Charge</strong> {customerShipTos?.find((s) => s.shipNo === shipToNumber)?.overMinCharge ?? '0.00'}
                </p>
              </Box>
            </Box>
          ) : (
            <Box className="order-summary-widget__no-items">No items in order.</Box>
          )}
        </Box>
      ) : (
        <Box onClick={() => onOpen()} className="order-summary-widget__show-btn">
          <ChevronLeftIcon />
          {/* <MonetizationOnIcon /> */}
          <div className="total">{formatter.format(total ?? 0)}</div>
        </Box>
      )}
    </div>
  );
};

export default OrderSummaryWidget;
